module.exports = __webpack_public_path__ + "img/map.8610026f.png";